import { Delete, Minus, Plus } from '@agendapro/emerald-icons';
import { FC } from 'react';
import { Paragraph } from '@/UI/Atoms';
import * as St from './Counter.styles';

const Counter: FC<{ handleMinus: () => void; handlePlus: () => void; amount: number }> = ({
  handleMinus,
  handlePlus,
  amount,
}) => (
  <St.Wrapper>
    <St.ActionBtn onClick={handleMinus}>{amount > 1 ? <Minus size={20} /> : <Delete size={20} />}</St.ActionBtn>
    <Paragraph data-cy="cart_dialog_amount">{amount}</Paragraph>
    <St.ActionBtn onClick={handlePlus} data-cy="cart_dialog_plus_button">
      <Plus size={20} />
    </St.ActionBtn>
  </St.Wrapper>
);

export default Counter;
